import { render, staticRenderFns } from "./AutocompleteDropdown.vue?vue&type=template&id=252adbc7"
import script from "./AutocompleteDropdown.vue?vue&type=script&lang=js"
export * from "./AutocompleteDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports